export default __webpack_public_path__ + "static/terra-55e862f3589a76849599f16f9140179c.png";